<template>
  <div o-Container o-Container-App>
    <div class="lancooHead">
      <div class="title-panel">{{title}}</div>
    </div>
    <iframe name="lanncooFrame"></iframe>
  </div>
</template>
<script>
  export default {
    name: "applet_main_login", /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    data() {
      return {
        octopus: this.$parent.octopus,
        title: '登陆中',
      }
    },
    created() {

    },
    activated: function () {
      let o = this;
      this.$nextTick(function () {
        o.init();
      });
      this.octopus.tips.debug("LancooLogin.vue执行了activated事件。");
    },
    methods: {
      init: function () {
        let o = this;
        // 获取小程序传过来的各项参数
        this.param = this.octopus.router.get().query;

        // 三方平台登录：蓝鸽平台。
        if (this.param.code) {
          $("iframe").attr("src", "login?code=" + this.param.code + "&lancooframe=true");
        }

        // 每秒更新一次抬头
        setTimeout(function () {
          o.runFrameTitle();
        }, 1000);
      },
      runFrameTitle: function () {
        let o = this;
        // console.error($("iframe").attr("src"));
        // let lf = $(window.frames["lanncooFrame"].document);
        // console.error(window.frames["lanncooFrame"].document.title)

        this.title = this.octopus.applet.getTitle();
        // console.error(this.octopus.applet.getTitle());

        setTimeout(function () {
          o.runFrameTitle();
        }, 2000);
      }
    },
    props: ["oData"]
  }
</script>
<style scoped>
  body {padding: 0px;margin: 0px;}
  .lancooHead {height: 80px;z-index: 7777;width: 100%;}
  .lancooHead .title-panel {
    background-color: #1bb4d6;
    width: 100%;
    text-align: center;
    padding: 45px 20px 15px 20px;
    font-size: 14px;
    font-weight: bold;
    color: #FFFFFF;
  }
  iframe {width: 100%;border: none;height: calc(100vh - 80px);}
</style>



// WEBPACK FOOTER //
// src/components/Main/App/Campus/Login/LancooPage.vue